export function getBrowser() {
    return window.navigator.userAgent;
}

export function getBrowserAndroidVersion() {
    let ua = window.navigator.userAgent;
    let version = ua.indexOf(' AppleWebKit/');
    if (version > 0) {
        return parseFloat(ua.substring(version + 13, ua.indexOf(' (KHTML', version)));
    }
    version =ua.indexOf(' Mobile Safari/');
    if (version > 0) {
        return parseFloat(ua.substring(version + 15, ua.length));
    } 
}

export function getBrowserCode() {
    return window.navigator.appCodeName;
}

export function getBrowserName() {
    return window.navigator.appName;
}

export function getBrowserVersion() {
    return window.navigator.appVersion;
}


export function isAvalibleBrowser() {
    let ua = window.navigator.userAgent;
    // IE 10 or older => return false
    if (ua.indexOf('MSIE ') > 0) {
        return false;
    }
    // IE 11 => return version number
    if (ua.indexOf('Trident/') > 0) {
        return false;
    }
    //Android
    if (ua.indexOf('Android ') > 0 && (getBrowserAndroidVersion() !==undefined && getBrowserAndroidVersion() < 537.36)) {
       return false;
    }
    return true;
}


// WEBPACK FOOTER //
// ./src/providers/BrowserProvider.js